import React, { useContext, useState } from 'react';
import { xs_isMobile } from '../..';
import { BetslipContext } from '../../data/betslip/BetslipConf';
import { classIf } from '../../data/utils/classIf';
import { getAmountInCent } from '../../data/utils/getAmountInCent';
import { getConfiguration } from '../../data/utils/configuration';
import { getLocaleDotRound } from '../../data/utils/getLocaleDotRound';
import { getPrintableAmount } from '../../data/utils/getPrintableAmount';
import { getValidAmountString } from '../../data/utils/getValidAmountString';

function StakesPicker(props) {
    const betslipContext = useContext(BetslipContext);
	let betslipData = betslipContext.getBetslipData();
	let conf = getConfiguration();
	let mult = conf.cs.m;
	let nDec = conf.cs.nd;
	const charDecimalBrowser = getLocaleDotRound().round;
	const charThousandBrowser = getLocaleDotRound().dot;
    const couponKey = props.couponKey;
    const coupon = betslipData.coupons[couponKey];

    const isEventForm = props.isEventForm;
    let event = null;
    if (isEventForm) {
    	const pal = props.pal;
    	const avv = props.avv;
    	if (coupon != null) {
    		for (var key in coupon.selections) {
    			var selection = coupon.selections[key];
    			if (selection.pal === pal && selection.avv === avv) {
    				event = selection;
    			}
    		}
    	}
    }
    
    // the amount we use to make calcs
    let amount = isEventForm && event ? event.bets[0].amount : coupon.amountMulti;

    function setAmount(settedAmount) {
        // get a valid input field value for this amount: only number and dot, and max nDec digit after it
        settedAmount = getValidAmountString(settedAmount, nDec);
        // putting the "browser decimal dot" instead of the "." for the float type
        let fieldTextValue = settedAmount;
        fieldTextValue = fieldTextValue.replace(".", charDecimalBrowser);
        let amountCentToSet = amount; // last valid amount
        
        // if is number, I calculate the new amount and I keep it into the field value. 
        // If not, I keep the field but I use the last valid amount for the calcs
        if (!isNaN(settedAmount) && settedAmount.length > 0) {
            amountCentToSet = getAmountInCent(parseFloat(settedAmount), mult);
        }
        
        if (isEventForm) {
            if (event != null) {
                const scomSogei = props.scomSogei;
                const handicap = props.handicap;
                const draw = props.draw;
                for (let km in event.bets) {
                    const bet = event.bets[km];
                    if (bet.scomSogei == scomSogei && bet.handicap == handicap && bet.draw === draw) {
                        bet.amount = amountCentToSet;
                        bet.printableAmount = fieldTextValue;
                    }
                }
            }
        } else {
            coupon.amountMulti = amountCentToSet;
            coupon.printableAmountMulti = fieldTextValue;
        }
        
        betslipContext.setBetslipData(betslipData, true);
    }
    
    function setAmountFromCalc(amountCalc){
        amountCalc = getPrintableAmount(amountCalc, mult, nDec);
        amountCalc = amountCalc.replaceAll(charThousandBrowser, ''); // remove the thousand char from the string. In the setAmount only "decimal" is permitted
        setAmount(amountCalc);
    }

    // the amount printed in the text field
    let printableAmount =  coupon.printableAmountMulti;
    if (isEventForm && event != null) {
        const scomSogei = props.scomSogei;
        const handicap = props.handicap;
        const draw = props.draw;
        for (let km in event.bets) {
            const bet = event.bets[km];
               if (bet.scomSogei == scomSogei && bet.handicap == handicap && bet.draw == draw) {
                   printableAmount = bet.printableAmount;
               }
        }
    }
   
    function addChar(el) {
        const symb = el.getAttribute('data-value') + '';
        let amountString = printableAmount + '';
        if (printableAmount === '0') {
            amountString = '';
        }
        amountString = amountString + symb;
        setAmount(amountString);
    }

    const [keypadToggled, setKeypadToggled] = useState(false);
    return (
        <>
            <div className="cart__footer__fixedInputsRow">
                {conf.bak.vls.map(a =>
                    <div key={a} className="cart__footer__fixedInputBtn" onClick={() => setAmountFromCalc(a)}>{getPrintableAmount(a, mult, nDec)}</div>
                )}
                {!xs_isMobile &&
                    <div className={"cart__footer__fixedInputBtn cart__footer__fixedInputBtn--calculator" + classIf(keypadToggled, 'cart__footer__fixedInputBtn--calculator--open')}
                            onClick={() => setKeypadToggled(!keypadToggled)}></div>
                }
            </div>
            {keypadToggled &&
                <div className="cart__footer__calculatorButtonsContainer cart__footer__calculatorButtonsContainer--open">
                    <div className="cart__footer__calculatorButton cart__footer__calculatorButton--1" data-value="1" onClick={(e) => addChar(e.target)}>1</div>
                    <div className="cart__footer__calculatorButton cart__footer__calculatorButton--2" data-value="2" onClick={(e) => addChar(e.target)}>2</div>
                    <div className="cart__footer__calculatorButton cart__footer__calculatorButton--3" data-value="3" onClick={(e) => addChar(e.target)}>3</div>
                    <div className="cart__footer__calculatorButton cart__footer__calculatorButton--4" data-value="4" onClick={(e) => addChar(e.target)}>4</div>
                    <div className="cart__footer__calculatorButton cart__footer__calculatorButton--5" data-value="5" onClick={(e) => addChar(e.target)}>5</div>
                    <div className="cart__footer__calculatorButton cart__footer__calculatorButton--6" data-value="6" onClick={(e) => addChar(e.target)}>6</div>
                    <div className="cart__footer__calculatorButton cart__footer__calculatorButton--7" data-value="7" onClick={(e) => addChar(e.target)}>7</div>
                    <div className="cart__footer__calculatorButton cart__footer__calculatorButton--8" data-value="8" onClick={(e) => addChar(e.target)}>8</div>
                    <div className="cart__footer__calculatorButton cart__footer__calculatorButton--9" data-value="9" onClick={(e) => addChar(e.target)}>9</div>
                    <div className="cart__footer__calculatorButton cart__footer__calculatorButton--0" data-value="0" onClick={(e) => addChar(e.target)}>0</div>
                    <div className="cart__footer__calculatorButton cart__footer__calculatorButton--delete" data-value="C" onClick={() => setAmount('0')}>C</div>
                    {nDec > 0 &&
                        <div className="cart__footer__calculatorButton cart__footer__calculatorButton--dot" data-value={charDecimalBrowser} onClick={(e) => addChar(e.target)}>{charDecimalBrowser}</div>
                    }
                </div>
            }
        </>
    );
}

export default StakesPicker;
